__turbopack_context__.v({
  "codeBlock": "help-module__nXAYjW__codeBlock",
  "codeCard": "help-module__nXAYjW__codeCard",
  "contactCard": "help-module__nXAYjW__contactCard",
  "container": "help-module__nXAYjW__container",
  "exampleBox": "help-module__nXAYjW__exampleBox",
  "explanation": "help-module__nXAYjW__explanation",
  "faqAnswer": "help-module__nXAYjW__faqAnswer",
  "faqItem": "help-module__nXAYjW__faqItem",
  "faqList": "help-module__nXAYjW__faqList",
  "faqQuestion": "help-module__nXAYjW__faqQuestion",
  "flowArrow": "help-module__nXAYjW__flowArrow",
  "flowCard": "help-module__nXAYjW__flowCard",
  "flowDiagram": "help-module__nXAYjW__flowDiagram",
  "flowStep": "help-module__nXAYjW__flowStep",
  "header": "help-module__nXAYjW__header",
  "section": "help-module__nXAYjW__section",
  "sectionTitle": "help-module__nXAYjW__sectionTitle",
  "stepNumber": "help-module__nXAYjW__stepNumber",
  "subtitle": "help-module__nXAYjW__subtitle",
  "techDetails": "help-module__nXAYjW__techDetails",
  "title": "help-module__nXAYjW__title",
});
